<template>
  <div>
    <div class="white-background common-font-size order-main" v-if="mode === 'main'">
      <div class="bottom-default-margin">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>生产管理</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span style="color:#000;font-weight:bold;">工单</span>
            </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
        <el-tab-pane :label="item.label" :name="item.id" v-for="item in tabList" :key="item.id">
          <span slot="label">
            <i class="el-icon-s-order" :style="{color:item.color}"></i>
            <span>{{item.label}}</span>
          </span>
          <!-- <el-row>
            <el-col :span="18">
                <div
                class="tag-item"
                :class="{'tag-item-active':item.label == activeLabel}"
                @click="labelClick(item)"
                v-for="item in tagType"
                :key="item.label">
                {{ item.label }}
                {{item.value}}
              </div>
            </el-col>
            <el-col :span="6">
              <el-input :placeholder="'输入' + searchSelectName + '搜索'" v-model="searchInputValue" class="input-with-select" :size="buttonSize" clearable>
                <el-select v-model="searchSelectValue" style="width:120px;" slot="prepend" placeholder="请选择" :title="searchSelectValue" @change="searchChange">
                  <el-option
                    v-for="item in searchOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" type="primary" :size="buttonSize" @click="search"></el-button>
              </el-input>
            </el-col>
          </el-row> -->
          <el-row class="default-top-bottom">
            <el-col :span="16">
              <el-button type="primary" icon="el-icon-plus" :size="buttonSize" @click="create">创建工单</el-button>
              <el-button size="small" type="primary" plain icon="el-icon-download" @click="templateDownload">模板下载</el-button>
              <el-button type="text" icon="el-icon-circle-plus-outline" @click="addTemplate">新增打印模板</el-button>
              <el-button type="text" icon="el-icon-edit-outline" @click="saveTemplate">编辑打印模板</el-button>
              <el-button size="small" type="success" plain icon="el-icon-upload2" @click="importData">导入</el-button>
              <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportDataNew">导出</el-button>


              <el-upload  ref="orderImp" name="upload" :action="action()" :on-change="
                  (file, fileList) => {
                  handleChange(file, fileList);
                  }
              "
                :auto-upload="false" :show-file-list="false" accept=".xlsx" v-show="false">

              </el-upload>
              <!-- <el-button type="primary" icon="el-icon-document-add" plain :size="buttonSize" @click="showImportLog">导入日志</el-button> -->
            </el-col>
            <el-col :span="8" class="text-align-right">
              <el-input :placeholder="'输入' + searchSelectName + '搜索'" v-model="searchInputValue" class="input-with-select" :size="buttonSize" clearable>
                <el-select v-model="searchSelectValue" style="width:120px;" slot="prepend" placeholder="请选择" :title="searchSelectValue" @change="searchChange">
                  <el-option
                    v-for="item in searchOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button slot="append" icon="el-icon-search" type="primary" :size="buttonSize" @click="search"></el-button>
              </el-input>
              <!-- <el-button type="primary" icon="el-icon-time" plain :size="buttonSize">操作记录</el-button> -->
            </el-col>
          </el-row>
          <el-table
            class="top-default-margin"
            size="small"
            :data="listData"
            :key="'table' + item.id"
            highlight-current-row
            v-loading="loading"
            stripe border
            element-loading-text="拼命加载中"
            :header-cell-style="_headerStyle"
            style="width: 100%;"
            row-key="_id"
            @selection-change="handleTblSelectionChange"
            :max-height="tableHeight"
            v-if="tableShow"
            >
            <el-table-column type="selection" :reserve-selection="true" width="60">
            </el-table-column>
            <el-table-column prop="no" label="序号" type="index" width="50"></el-table-column>
            <el-table-column sortable prop="orderCode" label="工单编号" width="220">
              <template slot-scope="scope">
                <el-button type="text" @click="doDetail(scope.row)">{{scope.row.orderCode}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  prop="productCode" label="产品编号" width="220">
              <template slot-scope="scope">
                <span>{{scope.row.productCode}}</span>
                <!-- <el-button type="text" @click="doDetail(scope.row)">{{scope.row.productInfo && scope.row.productInfo.productCode}}</el-button> -->
              </template>
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" width="80">
              <template slot-scope="scope">
                <div>{{scope.row.productName}}</div>
              </template>
            </el-table-column>
            <el-table-column  prop="specs" label="产品规格" width="80">
              <template slot-scope="scope">
                <div>{{scope.row.specs}}</div>
              </template>
            </el-table-column>
            <el-table-column  prop="orderStatus" label="状态" width="80">
              <template slot-scope="scope">
                <el-tag :type="changeStatusColor(scope.row.orderStatus)" size="small">{{scope.row.orderStatus}}</el-tag>
                <!-- <el-tag v-for="(item,index) in scope.row.orderStatus" :type="changeStatusColor(item)" :key="item" style="height:28px;" :style="{'marginBottom':(index!=scope.row.status.length-1)?'8px':'0'}">{{item}}</el-tag> -->
              </template>
            </el-table-column>
            <!-- <el-table-column  prop="priority" label="优先级" width="150"></el-table-column> -->
            <el-table-column  prop="produceTasks" label="工单进度条" width="400">
              <template slot-scope="scope">
                <div class="list-line-box">
                <div class="default-process-item" v-for="(item,index) in scope.row.produceTasks" :key="item.label">
                  <el-tooltip class="item" effect="dark" placement="right">
                      <div slot="content">
                        <div class="tootip-content">
                          <div style="font-size:14px;font-weight:bold;" class="bottom-small-margin content">{{item.processName}}</div>
                          <div>工序进度：{{item.goodNum?item.goodNum:0}}/{{item.planNum?item.planNum:0}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="content">工序计划数：{{item.planNum}}</div>
                          <div class="content">已报工良品数：{{item.goodNum}}</div>
                          <div>已报工不良品数：{{item.nongoodNum}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="content">已审批良品数：{{item.approvedGoodNum}}</div>
                          <div>未审批良品数：{{item.unapprovedGoodNum}}</div>
                          <el-divider class="small-row-margin"></el-divider>
                          <div class="bottom-mini-margin content">最近报工时间：{{item.updateTime}}</div>
                        </div>
                      </div>
                      <div>
                        <div style="display: flex; align-items: center;">
                          <div class="default-circle" :class="{'blue-circle':(item.process > 0 && item.process < 100) ,'green-circle':item.process >= 100}">
                            <div class="delay-tag default-delay-tag" v-if="item.exceed">逾</div>
                            <span class="default-percent-text" v-if="item.process < 100">{{item.process}}%</span>
                            <i class="el-icon-check" v-if="item.process >= 100"></i>
                          </div>
                          <span style="position: absolute;left: 48px;color: #bbb;" v-if="index!=(scope.row.produceTasks.length-1)">——</span>
                        </div>
                        <div class="process-text default-process-text" :title="item.processName" style="text-align: center;">{{item.processName}}</div>
                      </div>
                  </el-tooltip>
                </div>
              </div>
              </template>
            </el-table-column>
             <el-table-column sortable prop="relateDoc" label="销售订单" width="150">
              <template slot-scope="scope">
                <el-button type="text">{{scope.row.relateDoc}}</el-button>
              </template>
            </el-table-column>
            <el-table-column sortable prop="planStartTime" label="计划开始时间" width="150">
              <template slot-scope="scope">
                <div>{{scope.row.planStartTime}}</div>
              </template>
            </el-table-column>
            <el-table-column  prop="planEndTime" label="计划结束时间" width="150">
              <template slot-scope="scope">
                <div>{{scope.row.planEndTime}}</div>
              </template>
            </el-table-column>
            <el-table-column  prop="planNum" label="计划数" width="150"></el-table-column>
            <!-- <el-table-column  prop="editUser" label="实际数" width="150"></el-table-column> -->
            <el-table-column  prop="remark" label="备注" width="150"></el-table-column>

            <!-- <el-table-column  prop="unit" label="单位" width="150">
              <template slot-scope="scope">
                <div>{{scope.row.productInfo?scope.row.productInfo.unit:''}}</div>
              </template>
            </el-table-column> -->
            <el-table-column  prop="actualStartTime" label="实际开始时间" width="150"></el-table-column>
            <el-table-column  prop="actualEndTime" label="实际结束时间" width="150"></el-table-column>
            <!-- <el-table-column  prop="duration" label="报工时长" width="150"></el-table-column> -->


            <el-table-column v-for="item2 in setList" :key="item2._id" :prop="item2.fieldName" :label="item2.fieldName"></el-table-column>


            <el-table-column  prop="creater" label="创建人" width="150">
            </el-table-column>
            <el-table-column  prop="updater" label="更新人" width="150"></el-table-column>
            <el-table-column  prop="createTime" label="创建时间" width="150"></el-table-column>
            <el-table-column  prop="updateTime" label="更新时间" width="150"></el-table-column>
            <el-table-column label="操作" min-width="180" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="doDetail(scope.row)"  icon="el-icon-edit" circle title="编辑" :disabled="scope.row.orderStatus == '执行中' || scope.row.orderStatus == '已结束'"></el-button>
                <el-button type="primary" size="mini" @click="handlePrint(scope.row)" icon="el-icon-printer" circle title="打印"></el-button>

                <el-dropdown>
                  <span class="el-dropdown-link" style="padding-left: 7px;">
                    <el-button type="primary" size="mini" icon="el-icon-s-promotion" circle></el-button>

                    <!-- <span style="color:#409eff;cursor:pointer;">操作</span> -->
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item3 in dropdownOptions" :key="item3.label" @click.native="clickDropDown(item3.label,scope.row)" :disabled="changeDisabled(item3,scope.row)">
                      <i :class="item3.icon"></i>
                      {{item3.label}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-tab-pane>
      </el-tabs>
      <!-- <el-button icon="el-icon-plus" class="add-button" @click="addTab"></el-button> -->
      <el-drawer
        title="我是外面的 Drawer"
        :visible.sync="drawer"
        size="50%">
        <div>
        <el-button @click="innerDrawer = true">打开里面的!</el-button>
        <el-drawer
          title="我是里面的"
          :append-to-body="true"
          :before-close="handleClose"
          :visible.sync="innerDrawer">
          <p>_(:зゝ∠)_</p>
        </el-drawer>
        </div>
      </el-drawer>
    </div>
    <create-layout v-if="mode === 'create' || mode === 'edit' || mode === 'detail'  " :mode="mode" @done="done" :userData="userData" :editRow="editRow" :setList="setList" @goBack="goBack"></create-layout>
    <import-log v-if="mode === 'log'" :mode="mode"></import-log>
    <FilterScheme :diaVisible="filterSchemeVisible"  :listData="tabList" @filterRefresh="filterRefresh"></FilterScheme>
     <el-dialog
     title="打印"
     :visible.sync="printVisible"
     width="900px"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="done"
    >
    <print-layout v-if="printVisible" :userData="userData"  :editRow="editRow"  :type="'order'"  @done="done"></print-layout>
    </el-dialog>
    <el-dialog
      :title="templateTitle"
      :visible.sync="printTemplateVisible"
      width="900px"
      :show-close="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @close="done"
      >
      <print-template v-if="printTemplateVisible" :userData="userData"  :editRow="editRow" :type="'order'"   @done="done"></print-template>
      </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import { orderGetList,orderDelete ,orderBatchDelete,orderUpdateStatus} from '@/api/basicData';
import { queryAllCustomSet,orderBatchImp,exportExcel} from '@/api/business';

import Pagination from '@/components/Pagination'
import CreateLayout from "@/views/order/create-layout.vue";
import ImportLog from "@/views/order/import-log.vue";
import FilterScheme from "@/components/FilterScheme.vue";
import PrintLayout from "@/views/order/PrintLayout";
import PrintTemplate from "@/views/order/PrintTemplate";
import {exportDataToExcel,transfer} from '@/utils/util';


export default {
  // 注册组件
  components: {
    Pagination,
    CreateLayout,
    ImportLog,
    FilterScheme,
    PrintLayout,
    PrintTemplate
  },
  data() {
    return {
      tableHeight: 0,
      tableShow:false,
      mode:'main',
      buttonSize:'small',
      activeName:'0',
      tabList:[{
        id:'0',
        label:'全部',
        icon:'el-icon-tickets',
        color:'#333333'
      }],
      // listData:[{
      //   deptName:'111',
      //   status:['执行中','逾'],
      //   workOrderType:'正常排产',
      //   progress:[{label:'车轮组装',value:0,exceed:false},{label:'车架组装',value:0,exceed:false},{label:'整车调试',value:0,exceed:false}]
      // },{
      //   deptName:'111',
      //   status:['执行中','逾'],
      //   progress:[{label:'车轮组装',value:50,exceed:true},{label:'车轮调试',value:0,exceed:true},{label:'车架组装',value:0,exceed:true},{label:'整车调试',value:0,exceed:true}]
      // },{
      //   deptName:'111',
      //   status:['未开始','逾'],
      //   progress:[{label:'开料',value:100,exceed:true},{label:'粗车加工',value:0,exceed:true},{label:'滚齿',value:0,exceed:true},{label:'去毛刺',value:0,exceed:true},{label:'电镀',value:0,exceed:true},{label:'包装',value:0,exceed:true}]
      // }],
      listData:[],
      drawer: false,
      innerDrawer: false,
      loading:false,
      color:['#333333','#02B980','#1990FF','#FBB832','#FE5950'],
      tagType:[ { type: '', label: '全部',value:12 },
      { type: 'success', label: '未开始',value:12 },
      { type: 'info', label: '执行中' ,value:12},
      { type: 'danger', label: '已结束' ,value:12},
      { type: 'warning', label: '已取消' ,value:12}],
      activeLabel:'全部',
      searchInputValue:'',
      searchSelectValue:'orderCode',
      searchOptions:[
         {
          value: 'orderCode',
          label: '工单编号'
        }, {
          value: 'productCode',
          label: '产品编号'
        }, {
          value: 'productName',
          label: '产品名称'
        }, {
          value: 'specs',
          label: '产品规格'
        }, {
          value: 'remark',
          label: '工单备注'
        },{
          value: 'relateDoc',
          label: '销售订单'
        },
        //  {
        //     value: '车间类型',
        //     label: '车间类型'
        //   }, {
        //     value: '重量',
        //     label: '重量'
        //   }
      ],
      dropdownOptions:[{
          value: '开始',
          label: '开始',
          disabled:true,
          icon:'el-icon-video-play'
        },
        // {
        //   value: '打印',
        //   label: '打印',
        //   disabled:false,
        //   icon:'el-icon-printer'
        // },{
        //   value: '加急',
        //   label: '加急',
        //   disabled:false,
        //   icon:'el-icon-lightning'
        // },
        // {
        //   value: '复制',
        //   label: '复制',
        //   disabled:false,
        //   icon:'el-icon-copy-document'
        // },
        {
          value: '结束',
          label: '结束',
          disabled:false,
          icon:'el-icon-s-help'
        },{
          value: '撤回',
          label: '撤回',
          disabled:false,
          icon:'el-icon-refresh-left'
        },{
          value: '取消',
          label: '取消',
          disabled:false,
          icon:'el-icon-zoom-out'
        },{
          value: '删除',
          label: '删除',
          disabled:false,
          icon:'el-icon-delete'
      },],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      form: {
        page: 1,
        limit: 10,
      },
      editRow:{},
      filterSchemeVisible:false,
      userData:{},
      modelStatus:'',
      searchSelectName:'工单编号',
      unitList:[],
      setList:[],
      printVisible:false,
      printTemplateVisible:false,
      templateTitle:'新增打印模板',
      tblSelectionList:[],
    }
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData);
      this.init();
    }

  },
  mounted() {
    console.log(window.innerHeight);
    this.tableHeight = window.innerHeight - 350;
    this.tableShow = true
  },
  methods: {
    /**
     * 监听表格选中项变化事件
     */
     handleTblSelectionChange(val) {
      this.tblSelectionList = val;

    },
     //导出数据前对数据处理，变为想要的格式。
     filterTableData(data) {
      data.forEach((item) => {
        item.productCode = item.productCode? item.productCode:'';
        item.productName =item.productName? item.productName:'';
        item.specs = item.specs?item.specs:'';
      });
      return data;
    },
    exportDataNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        // this.$message({
        //     type: 'warning',
        //     message: '请选择需要导出的数据'
        // });
        this.exportData();
        return;
      }
      const header = [
        "工单编号",
        '产品编号',
        '产品名称',
        '产品规格',
        '状态',
        '计划开始时间',
        '计划结束时间',
        '计划数',
        '备注',
        '实际开始时间',
        '实际结束时间',
        '创建人',
        '创建时间',
        '更新人',
        '更新时间',

      ];
      const filterVal = [
        'orderCode',
        'productCode',
        'productName',
        'specs',
        'orderStatus',
        'planStartTime',
        'planEndTime',
        'planNum',
        'remark',
        'actualStartTime',
        'actualEndTime',
        'creater',
        'createTime',
        'updater',
        'updateTime',

      ];
      for(let k = 0;k<this.setList.length;k++){
        header.push(this.setList[k]['fieldName']);
        filterVal.push(this.setList[k]['fieldName']);
      }
      let filterData =this.filterTableData(JSON.parse(JSON.stringify(this.tblSelectionList)));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"工单清册"+Date.now());
    },
    exportData(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
        },
        tableName:'工单',
        collection:'order',
      }
      params.condition[this.searchSelectValue] = this.searchInputValue

      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "工单清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

      },
     addTemplate(){
      this.templateTitle = "新增打印模板"
      this.editRow = null;
      this.printTemplateVisible = true;
    },
    saveTemplate(){
      this.templateTitle = "编辑打印模板"
      this.editRow = this.listData[0];
      this.printTemplateVisible = true;


    },
    handlePrint(row){

      this.editRow = row;
      this.printVisible = true;
    },
    handleChange(file, fileList){
        let data = new FormData();

        data.append("file", file.raw);
        data.append("factoryId ", this.userData.factoryId);
        data.append("creater",this.userData.name + "(" + this.userData.account + ")");
        orderBatchImp(data).then(res=>{
          this.search();

        });

    },
    action(){
      return this.$devEnv.API_ROOT + `/order/importData`;
    },
    templateDownload(){
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/order/downloadTemplate';
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "工单导入模板.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send();
    },
    importData(){
      this.$refs["orderImp"][0].$refs['upload-inner'].handleClick();
    },
    init(){
      queryAllCustomSet(this.userData.factoryId,'order').then(res=>{
        this.setList = [];
        if(res['code'] == 200){
          this.setList = res['data'];
          this.getdata();
        }
      })
    },
    getdata() {
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      params.condition[this.searchSelectValue] = this.searchInputValue
      orderGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
          this.listData.map(function(item){
            // item.progress = []
            if(item.produceTasks){

              item.produceTasks.map(function(item1){
                // var tem = item1
                if(item1.goodNum == '-'){
                  item1.goodNum = 0
                }
                if(item1.planNum == '-'){
                  item1.planNum = 0
                }
                if(item1.nongoodNum == '-'){
                  item1.nongoodNum = 0
                }
                if(item1.goodNum && item1.planNum){
                  item1.process = ((item1.goodNum/item1.planNum) * 100).toFixed(2);
                }else{
                  item1.process = 0
                }
                // item.progress.push(tem)
              })
            }
          })
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    searchChange(){
      var res = this.searchOptions.filter(function(item){return item.value == this.searchSelectValue}.bind(this))
      if(res && res.length!=0){
        this.searchSelectName = res[0].label
      }
    },
    handleClose(done) {
      this.$confirm('还有未保存的工作哦确定关闭吗？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleClick(){
      this.drawer = true
    },
    labelClick(options){
      this.activeLabel = options.label;
    },
    changeStatusColor(options){
      if(options == '逾'){
        return 'danger'
      }else if(options == '执行中'){
        return 'success'
      }else if(options == '已取消'){
        return 'warning'
      }else if(options == '已结束'){
        return 'info'
      }else{
        return ''
      }
    },
    create(){
      this.mode = 'create'
    },
    done(options){
      this.printVisible = false;
      this.printTemplateVisible = false;
      this.mode = 'main'
      if(options && options.type == 'save'){
        this.getdata()
      }
    },
    showImportLog(){
      this.mode = 'log'
    },
    doDetail(row){
      this.editRow = row;
      this.mode = 'detail';
    },
    addTab(){
      this.filterSchemeVisible = true;
    },
    filterRefresh(){
      this.filterSchemeVisible = false;
    },
    handleDelete(row){
      this.$confirm('删除后，将同时删除关联的工单、任务和报工，且不可恢复。是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          // const pageLoading = this.openLoading(); //调用方法，打开loading遮罩层
          orderDelete(row._id,this.userData.factoryId,row.orderCode).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
              // pageLoading.close();
          }).catch(err => {
            // pageLoading.close();
            this.$message.error('删除失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.listData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          orderBatchDelete(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    clickDropDown(options,row){
      if(options == '删除'){
        this.handleDelete(row)
      }else if(options == '结束' || options == '撤回' || options == '开始' ||options == '取消' ){
        var status = ''
        switch (options) {
          case '开始':
            status = '执行中'
            break;
          case '撤回':
              if(row.orderStatus == '执行中'){
                status = '未开始'
              }else if(row.orderStatus == '已结束'){
                status = '执行中'
              }
              break;
          case '结束':
            status = '已结束'
            break;
          case '取消':
            status = '已取消'
            break;
          default:
            break;
        }
        orderUpdateStatus(row.orderCode,options,status).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message:"操作成功"
            })
            this.getdata()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }
    },
    search(){
      this.pageparm.currentPage =1;
      this.pageparm.pageSize = 10;
      this.getdata()
    },
    // unitFormat(val){
    //   var res = this.unitList.filter(function(item){
    //     return item.unitName == val.unit
    //   })
    //   if(res && res.length!=0){
    //     return res[0].name
    //   }else{
    //     return ''
    //   }
    // },
    goBack(){
      this.mode = 'main'
    },
    changeDisabled(item,row){
      if(row.orderStatus == '执行中' && item.label == '开始'){
        return true;
      }
      if(row.orderStatus == '未开始' && (item.label == '结束' || item.label == '撤回'  ||item.label == '取消')){
        return true;
      }
      if(row.orderStatus == '已取消' && item.label == '撤回'){
        return true;
      }
      return false;
    },
  }
}
</script>

<style scoped>
.el-icon-plus:hover{
  color: #1890ff;
}
.order-main{
  position: relative;
}
.add-button{
  position: absolute;
  top: 55px;
  right: 16px;
  padding: 4px;
}
.bottom-default-margin{
  margin-bottom: 15px;
}
.el-icon-s-order{
  font-size: 16px;
}
.tag-item{
  display: inline-block;
  height: 32px;
  padding: 0 12px;
  line-height: 30px;
  font-size: 12px;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  cursor: pointer;
  background-color: #f1f8f8;
  color: #909399;
  margin-right: 15px;
  color: #666;
}
.tag-item:hover{
  background-color: #f0f2f6;
}
.tag-item-active{
  color: #409eff;
  background-color: #ecf5ff;
}
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff!important;
}
.el-input-group__append .el-button--primary{
  color: #fff;
  background-color: #1890ff;
  border-radius: 0 4px 4px 0;
}
.default-circle{
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid rgb(204, 204, 204);
  }
  .blue-circle{
  border: 3px solid rgb(0, 120, 231);
  }
  .green-circle{
    color: #02b980;
    font-size: 35px;
    font-size: 21px;
    border: 3px solid rgb(2, 185, 128);
  }
  .default-percent-text{
    font-weight: 600;
    font-size: 10px;
    white-space: nowrap;
    vertical-align: middle;
    transform: scale(.83);
  }

  .default-process-item {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 36px;
    margin-right: 50px;
    margin-bottom: 20px;
}
.list-line-box {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 8px;
    overflow-y: hidden;
}
.default-process-text {
    position: absolute;
    left: 18px;
    max-width: 72px;
    margin-top: 2px;
    font-size: 12px;
    line-height: 12px;
    transform: translateX(-50%);
    bottom: -18px;
}

.default-delay-tag {
    position: absolute;
}
.delay-tag {
  top: -5px;
  right: -7px;
  margin-right: 2px;
  color: #fff;
  font-size: 10px;
  background-color: #ff393d;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  -webkit-transform: scale(.83);
  transform: scale(.83);
}
.tootip-content .content{
  height: 24px;
}
.el-divider{
  background-color: #575859;
}
</style>
<style>
.process-text {
    width: 50px;
    overflow: hidden;
    color: #333;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/order/Order.vue